<template>
  <div class="pay-success flex-col">
    <div class="ptitle blod">开店申请提交成功，请您扫码支付店铺年服务费</div>
    <div class="ptitle blod">
      支付金额(元): <span class="text-red">￥{{ cost }}</span>
    </div>
    <div style="margin-top: -10px">
      <a style="color: #0089ef; font-size: 14px" @click="goHomePage"
        >返回首页</a
      >
    </div>
    <div class="flex-col" v-if="isPaySuccess">
      <img
        src="./img/success.png"
        alt=""
        style="width: 79px; height: 79px; margin-top: 60px"
      />
      <span style="margin: 30px 0 228px 0; font-size: 24px; color: #4a4a4a"
        >支付成功</span
      >
    </div>
    <div class="qrcode flex-col" v-else>
      <div class="img-box" v-loading="!url">
        <img
          v-if="url"
          :src="url"
          alt=""
          style="width: 276px; height: 276px; object-fit: contain"
        />
      </div>
      <div style="font-size: 16px; padding: 20px 0 30px 0">
        <span v-if="payTime > 0"
          >请在
          <span style="color: #ff0037">{{ payTime }}</span> 秒内扫码支付</span
        >
        <span style="color: #0089ef; cursor: pointer" @click="reloimg">
          刷新</span
        >
      </div>
    </div>
  </div>
</template>
  
  <script>
export default {
  data() {
    return {
      loading: true,
      cost: "3000.00",
      payTime: 90,
      url: "",
      isPaySuccess: false,
      timel: null,
    };
  },

  methods: {
    goHomePage() {
      this.$router.push("/index");
    },
    startDJS(val) {
      this.payTime == 90;
      clearInterval(this.timel);
      this.url = val.imageUrl;
      this.loading = false;
      this.timel = setInterval(() => {
        this.payTime--;
        if (this.payTime === 0) {
          clearInterval(this.timel);
        }
      }, 1000);
    },
    reloimg() {
      this.$emit("reloimg");
      //imageUrl:'http://cccc-test.obs.cn-north-4.myhuaweicloud.com/cccc_temp/temp38e793e8825d41d1aac05d6c71376cfd.png?AccessKeyId=VQWZQULFDTWJPDLZDNHH&Expires=1750145566&Signature=%2FVWxDI1Pdd5hZJvk7r3rEEZ2Yec%3D'}
    },
    paySuccess() {
      this.isPaySuccess = true;
    },
  },
};
</script>
  
  <style lang="scss" scoped>
.pay-success /deep/.el-loading-spinner {
  margin-top: 0;
  margin-left: 0;
  transform: translate(-50%, -50%);
}
.pay-success {
  width: 100%;
}
.flex-col {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.ptitle {
  color: #4a4a4a;
  font-size: 20px;
  margin-bottom: 20px;
}
.qrcode {
  width: 100%;
  border-top: 1px solid #f2f2f2;
  margin-top: 20px;
  padding: 20px 0;
  .img-box {
    width: 296px;
    height: 296px;
    border-radius: 8px;
    border: 1px solid #e9e9e9;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.blod {
  font-weight: 600;
}
.text-red {
  color: #ff142f;
}
</style>